export const SEND_EMAIL = `/user/send-email`;
export const VERIFY_EMAIL = `/user/verify-email`;
export const REGISTER_COMPANY = `/user/companies`;
export const REGISTER_FOR_DEMO = `/demo/register`;

export const GET_LOCATION_BY_POSTALCODE = "/locations?postalCode={postalCode}";
export const UPLOAD_FILE = "/upload";
